import axios from 'axios';
import {
  ADD_EXPENSECAT_ENDPOINT,
  API_CALL_ERROR,
  DELETE_EXPENSECAT_ENDPOINT,
  UPDATE_EXPENSECAT_ENDPOINT,
} from './_ConstantsAPI';





export async function addExpenseCat(payload) {
  try {
    console.log(payload);
    const { data } = await axios.post(ADD_EXPENSECAT_ENDPOINT, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}

export async function updateExpenseCat(payload) {
  try {
    console.log(payload)
    const { data } = await axios.post(UPDATE_EXPENSECAT_ENDPOINT, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}

export async function deleteExenseCat(payload) {
  try {
    const { data } = await axios.post(DELETE_EXPENSECAT_ENDPOINT, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}
